import { useNavigate, useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../../components/constant/reportType";
import { Descriptions, Radio, RadioChangeEvent, Switch, Table } from "antd";
import { ORGANIZATION_MASTER_COLUMN } from "../../components/constant/AppConstant";
import { BsPencilSquare, BsPlus, BsSearch } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import MasterReportData from "./MasterReportData";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useDeleteOrganizationMasterMutation, useGetAllOrganizationMasterBySearchMutation, useGetAllOrganizationMasterMutation } from "../../redux-toolkit/services/organizationMasterService";
import { allOrganizationMasterDetails, getAllOrganizationMasterBySearch, getOrganizationMasterTotalRecords, setAllOrganizationMasterBySearch, setOrganizationMaster } from "../../redux-toolkit/slices/organizationMasterSlice";

type Props = {};
const DataSourceMangement = (props: Props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");
    console.log(call, "call");
    const [isCategory, setIsCategory] = useState(false);

    //getMutations
    const [getAllOrganizationMaster, allOrganizationMasterResponse] = useGetAllOrganizationMasterMutation();

    //search


    //delete mutation
    const [deleteOrganizationMaster, deleteOrganizationMasterResponse] = useDeleteOrganizationMasterMutation();

    //totalRecords
    const totalOrganizationMaster: any = useAppSelector(getOrganizationMasterTotalRecords);

    //selector

    const allOrganizationMaster: any = useAppSelector(allOrganizationMasterDetails);
    const allOrganizationMasterBySearch: any = useAppSelector(getAllOrganizationMasterBySearch);

    useEffect(() => {
        switch (params.reportType) {

            case REPORT_PATH.ORGANIZATION_MASTER:
                setReportName(REPORT_NAME.ORGANIZATION_MASTER)
                break;

            default:
        }
    }, [params.reportType]);

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-accent" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    console.log(record, "record")
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {record.status === true ||
                            record.enabled === true ||
                            record.isActive === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.ORGANIZATION_MASTER && ORGANIZATION_MASTER_COLUMN) {
            ORGANIZATION_MASTER_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }

    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.ORGANIZATION_MASTER) {
            setIsCategory(true);
            getAllOrganizationMaster({
                token: localUserObj?.token,
                payload: {
                    page: currentpage - 1,
                    size: pageSize,
                    orderBy: "desc",
                }
            });
        }

    }, [reportName]);

    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.ORGANIZATION_MASTER) {
                setIsCategory(true);
                getAllOrganizationMaster({
                    token: localUserObj?.token,
                    payload: {
                        searchBy: "",
                        offset: pageSize,
                        pageNumber: currentpage - 1,
                        sortDir: "asc"
                    }
                });
                setCall("N");
            }
        }
    }, [call]);

    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.ORGANIZATION_MASTER) {
            getAllOrganizationMaster({
                token: localUserObj?.token,
                payload: {
                    searchBy: "",
                    offset: pageSize,
                    pageNumber: currentpage - 1,
                    sortDir: "asc"
                }
            });
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.ORGANIZATION_MASTER) {
            deleteOrganizationMaster({
                id: record.id,
                token: localUserObj?.token,
            });

            const payload = {
                tableName: REPORT_NAME.ORGANIZATION_MASTER,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

        }
    };

    useEffect(() => {
        if (deleteOrganizationMasterResponse.isSuccess) {
            if (deleteOrganizationMasterResponse.data?.isActive) {
                alertMessage("Organization Master enable successfully", "success");
            } else {
                alertMessage("Organization Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteOrganizationMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteOrganizationMasterResponse.isSuccess, deleteOrganizationMasterResponse.isError]);

    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    useEffect(() => {
        if (allOrganizationMasterResponse.isSuccess) {
            dispatch(setOrganizationMaster(allOrganizationMasterResponse));
        } else if (allOrganizationMasterResponse.isError) {
            let response: any = allOrganizationMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [allOrganizationMasterResponse.isSuccess, allOrganizationMasterResponse.isError]);

    useEffect(() => {
        if (allOrganizationMaster && reportName === REPORT_NAME.ORGANIZATION_MASTER) {
            setDatasource(allOrganizationMaster);
        }
    }, [allOrganizationMaster]);

    const handleSearch = (event: any) => {

    };

    useEffect(() => {
        if (allOrganizationMasterBySearch && reportName === REPORT_NAME.ORGANIZATION_MASTER) {
            setDatasource(allOrganizationMasterBySearch);
        }
    }, [allOrganizationMasterBySearch]);

    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-accent"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex flex-column">
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    {/* <img src={gear} alt="" /> */}
                                    <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex px-2 align-items-center mt-1">
                        <Button
                            // variant="primary"
                            className="d-flex align-items-center me-0 text-nowrap bg-accent"
                            onClick={handleShow}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>
                    {allOrganizationMasterResponse.isLoading ||
                        deleteOrganizationMasterResponse.isLoading
                        
                        ? (
                            <Loading />
                        ) : (
                            ""
                        )}
                    {show && (
                        <MasterReportData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                            isCategory={isCategory}
                            setIsCategory={setIsCategory}
                        />
                    )}
                </div>
            </div>
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    scroll={{ x: 'max-content' }}
                    tableLayout="fixed"
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.ORGANIZATION_MASTER:
                                    return totalOrganizationMaster;
                                default:
                                    return dataSource.length;
                            }
                        })(),
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};
export default DataSourceMangement;